
import { SVGProps } from 'react';

const ArrowBack = ({
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49121 0L9.41045 0.919239L2.49277 7.83691L24.605 7.83691V9.13691L2.48408 9.13691L9.50122 16.1541L8.58198 17.0733L0.0956544 8.58696L0.095704 8.58691L0 8.49121L8.49121 0Z" fill="#2A2A2A" />
    </svg>
);

export default ArrowBack;

